
export default function Testimonials() {
  const testimonials = [
    {
      stars: 5,
      headline: 'Cut our lead costs in half',
      review: 'Green Leads Network delivered exactly what they promised. Our Instagram campaigns are now generating quality leads at half the cost we were paying before. The setup was smooth and their team knows the landscaping industry inside out.',
      name: 'Sarah Mitchell',
      role: 'Owner, GreenScape Solutions',
      avatar: 'https://i.pravatar.cc/150?img=1'
    },
    {
      stars: 5,
      headline: 'Best marketing investment we made',
      review: 'We were skeptical at first, but the results speak for themselves. Within the first month, we had more qualified leads than the entire previous quarter. The content they create is professional and really resonates with our target customers.',
      name: 'James Thompson',
      role: 'CEO, Elite Lawn Care',
      avatar: 'https://i.pravatar.cc/150?img=12'
    },
    {
      stars: 5,
      headline: 'Finally, marketing that works',
      review: 'After trying multiple marketing agencies, Green Leads Network is the first one that actually understands our business. Their Instagram strategy is spot-on and the leads keep coming in consistently.',
      name: 'Maria Garcia',
      role: 'Founder, Pristine Gardens',
      avatar: 'https://i.pravatar.cc/150?img=5'
    },
    {
      stars: 5,
      headline: 'Incredible ROI and support',
      review: 'The one-time setup fee was worth every penny. We are now getting 10x more leads than before, and the quality is outstanding. Their management service takes all the stress out of social media marketing. Highly recommend to any landscaping business looking to grow.',
      name: 'David Chen',
      role: 'Director, Urban Oasis Landscaping',
      avatar: 'https://i.pravatar.cc/150?img=14'
    },
    {
      stars: 5,
      headline: 'Game changer for our business',
      review: 'Green Leads Network transformed how we acquire customers. The Instagram campaigns they run are professional, targeted, and most importantly, they convert. We have been able to scale our business faster than we ever thought possible.',
      name: 'Jennifer Williams',
      role: 'Owner, Nature\'s Touch Landscaping',
      avatar: 'https://i.pravatar.cc/150?img=9'
    },
    {
      stars: 5,
      headline: 'Professional and results-driven',
      review: 'What sets Green Leads Network apart is their deep understanding of both Instagram marketing and the landscaping industry. They do not just post content, they create campaigns that actually bring in customers. Our booking calendar is now full months in advance.',
      name: 'Robert Anderson',
      role: 'Managing Partner, Evergreen Landscapes',
      avatar: 'https://i.pravatar.cc/150?img=13'
    }
  ];

  return (
    <section id="testimonials" className="py-16 sm:py-32 bg-amber-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16 space-y-3 sm:space-y-4">
          <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
            <div className="w-3 h-3 rounded-full bg-emerald-600"></div>
            <span className="text-xs sm:text-sm font-semibold text-emerald-700 uppercase tracking-wider">Client Success Stories</span>
          </div>
          <h2 className="text-3xl sm:text-6xl font-extrabold text-gray-900 leading-tight">
            Real Results from Real<br />Landscaping Businesses
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-2xl mx-auto">
            See how we have helped landscaping companies transform their lead generation
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <div className="flex gap-1 mb-4 sm:mb-5">
                {[...Array(testimonial.stars)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-xl text-amber-400"></i>
                  </div>
                ))}
              </div>
              
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                {testimonial.headline}
              </h3>
              
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-6 sm:mb-8 flex-grow" style={{ lineHeight: '1.6' }}>
                {testimonial.review}
              </p>
              
              <div className="flex items-center gap-3 sm:gap-4 mt-auto">
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.name}
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-white shadow-md object-cover"
                />
                <div>
                  <div className="text-sm sm:text-base font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-xs sm:text-sm text-gray-500">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
